export default "__VITE_ASSET__DMNA155v__"